import { List } from 'immutable';
import Constants from '../constants';
import InviteRequestListItemRecord from './InviteRequestListItemRecord';
import InviteRequestStatusCountRecord from './InviteRequestStatusCountRecord';

const createInviteRequestList = (inviteRequests: any[]) => {
  const listItems = inviteRequests.map(inviteRequest => {
    const validCommands = inviteRequest.validCommands;
    const isApprovable =
      validCommands && validCommands.includes(Constants.APPROVE);
    const isRejectable =
      validCommands && validCommands.includes(Constants.REJECT);

    return new InviteRequestListItemRecord({
      ...inviteRequest,
      approvable: isApprovable,
      rejectable: isRejectable,
    });
  });

  return List(listItems);
};

const createStatusCount = statusCount => {
  return new InviteRequestStatusCountRecord({
    approved: statusCount.approved,
  });
};

export default {
  createInviteRequestList,
  createStatusCount,
};
